import { ListPageSkeleton } from '@practium/ui';

export const LogsPageSkeleton = () => (
	<ListPageSkeleton
		tabsCount={1}
		headerActionsCount={1}
		tableRows={8}
		sidebarWidth="27rem"
		sidebarW1500="22rem"
		sidebarW1300="19rem"
		sidebarW1200="17rem"
		sidebarCardsCount={1}
	/>
);
